import { Cross2Icon } from "@radix-ui/react-icons";
import {
  Box,
  Button,
  Dialog,
  Flex,
  Text,
  VisuallyHidden,
} from "@radix-ui/themes";
import { createColumnHelper } from "@tanstack/react-table";
import { useState, useMemo } from "react";
import { DataTable } from "./data-table";

type DialogTableProps = {
  data: Record<string, number | number[]>[];
};

export function DialogTable({ data }: DialogTableProps) {
  const [columnHelper] = useState(() => createColumnHelper<any>());

  const columns = useMemo(() => {
    const columnKeys = Object.keys(data[0]);

    return columnKeys.map((key) => {
      if (key === "connected_track_ids") {
        return columnHelper.accessor(key, {
          header: () => (
            <span className="capitalize">{key.split("_").join(" ")}</span>
          ),
          cell: ({ getValue }) => {
            return (
              <Box>
                {getValue().map((trackId: string) => (
                  <Text as="p" key={trackId}>
                    {trackId}
                  </Text>
                ))}
              </Box>
            );
          },
        });
      }

      return columnHelper.accessor(key, {
        header: () => (
          <span className="capitalize">{key.split("_").join(" ")}</span>
        ),
      });
    });
  }, [data, columnHelper]);

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <Flex justify="center">
          <Button variant="soft" color="gray" size="1">
            View Details
          </Button>
        </Flex>
      </Dialog.Trigger>
      <Dialog.Content
        minWidth="80dvw"
        minHeight="70dvh"
        className="p-1"
        aria-describedby={undefined}
      >
        <Dialog.Close className="absolute top-2.5 right-2.5">
          <Button variant="soft" color="gray" size="2">
            <Cross2Icon />
            Close
          </Button>
        </Dialog.Close>
        <VisuallyHidden>
          <Dialog.Title>Track Anomaly Indicators</Dialog.Title>
        </VisuallyHidden>
        <Flex direction="column" className="h-[calc(70dvh-2.575rem)]">
          <DataTable
            loading={false}
            isSuccess={true}
            totalCount={data.length}
            data={data}
            columns={columns}
            title="Track Anomaly Indicators"
            emptyTitle="Empty"
            emptyDescription={""}
          />
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
